<template>
    <v-dialog v-model="addProductPriceDialog">
        <v-card width="1000px" class="py-6">
            <v-form ref="form" lazy-validation>
                <h1>{{ ProductPrice ? $t('actions.edit') : $t('priceLists.add') }}</h1>
                <div class="row ma-2 my-8">
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left">{{ $t('products.title') }} <span class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <v-text-field v-model="name" id="name" name="name" hide-details persistent-placeholder
                                required maxlength="30"
                                :placeholder="$t('placeholder.enter', { itm: $t('products.title') })"
                                variant="outlined">
                            </v-text-field>
                            <span class="warningHint" id="WarningMsgUserName">{{ msg.name }}</span>
                        </div>
                    </div>
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left">{{ $t('products.description') }} <span class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <v-text-field v-model="description" id="descriptionPrice" name="description" hide-details
                                persistent-placeholder required maxlength="128"
                                :placeholder="$t('placeholder.enter', { itm: $t('products.description') })"
                                variant="outlined"></v-text-field>
                            <span class="warningHint" id="WarningMsgEmail">{{ msg.description }}</span>
                        </div>
                    </div>
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left">{{ $t('priceLists.startDate') }} <span class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <span lang="en-CA" xml:lang="en-CA">
                                <dateField v-model="startDate" :minDate="new Date()" />
                            </span>
                            <span class="warningHint" id="WarningMsgRole">{{ msg.startDate }}</span>
                        </div>
                    </div>
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left">{{ $t('priceLists.endDate') }} <span class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <span lang="en-CA" xml:lang="en-CA">
                                <dateField v-model="endDate" :minDate="new Date()" />
                            </span>
                            <span class="warningHint" id="WarningMsgRole">{{ msg.endDate }}</span>
                        </div>
                    </div>

                    <div class="col-6 justify-content-start" v-if="!ProductPrice?.id">
                        <div class="row">
                            <v-card-title class="text-left">Type Discount <span class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <span lang="en-CA" xml:lang="en-CA">
                                <v-select v-model="discountType" :items="discountTypeList" item-title="name"
                                    item-value="value" density="compact" hide-details variant="outlined" />

                            </span>
                            <!-- <span class="warningHint" id="WarningMsgRole">{{ msg.endDate }}</span> -->
                        </div>
                    </div>
                    <div class="col-12">
                        <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                            <v-tab class="slider" value="option-1" centered v-model="general"
                                style="pointer-events: none;">
                                {{ $t('products.variants') }}
                            </v-tab>
                        </v-tabs>
                        <v-divider class="mt-0 mb-4"></v-divider>
                        <div class="col-12 justify-content-center">
                            <!-- {{ProductVariants}}{{ items }} -->
                            <!-- {{discountType}} -->
                            <v-card v-if="ProductVariants.length > 0" variant="outlined">
                                <v-table>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Variant</th>
                                            <th class="text-left">Base Price</th>
                                            <!-- <th class="text-left" v-if="discountType == 0">Fix price</th> -->
                                            <th class="text-center" v-if="discountType == 1">Percentage</th>
                                            <th class="text-center" v-if="discountType == 2">Interval by quantity</th>
                                            <th class="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(variant, index) in items" :key="variant.id || index">
                                            <td>{{ getVariantTitle(variant) }}</td>
                                            <td style="width: 150px">
                                                {{ formatPrice(variant.price) }}
                                            </td>
                                            <td style="width: 150px" v-if="discountType == 0">
                                                <v-text-field v-model.number="variant.discountAmount" type="number"
                                                    density="compact" hide-details variant="outlined"
                                                    :disabled="!variant.isActive" />
                                            </td>
                                            <td style="width: 150px" v-if="discountType == 1">
                                                <v-text-field v-model.number="variant.discountPercentage" type="number"
                                                    density="compact" hide-details variant="outlined" suffix="%"
                                                    :disabled="!variant.isActive" min="0" max="100" />
                                            </td>
                                            <td class="text-center" style="width: 400px; text-align: center"
                                                v-if="discountType == 2">
                                                <table style="margin: 0 auto; text-align: center;">
                                                    <thead>
                                                        <tr>
                                                            <th>Quantity</th>
                                                            <th class="text-center">-></th>
                                                            <th>type</th>
                                                            <th style="min-width: 90px">price</th>
                                                            <th style="min-width: 50px"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(priceInfo, index) in variant.pricePerQuantity.slice(0, 1)"
                                                            :key="index">
                                                            <td style="width: 90px">
                                                                <v-text-field v-model.number="priceInfo.quantity"
                                                                    type="number" density="compact" hide-details
                                                                    variant="outlined" disabled />
                                                            </td>
                                                            <td class="text-center" style="width: 20px">-></td>
                                                            <td class="text-center" style="width: 70px;">
                                                                <v-checkbox v-model="priceInfo.isPercentage" label="%"
                                                                    hide-details
                                                                    @change="updateIsPercentage(priceInfo, variant.price)" />
                                                            </td>
                                                            <td style="width: 110px">
                                                                <v-text-field v-if="priceInfo.isPercentage"
                                                                    v-model.number="priceInfo.percentage" type="number"
                                                                    density="compact" suffix="%" hide-details
                                                                    variant="outlined" :disabled="!variant.isActive"
                                                                    min="0" max="100" />
                                                                <v-text-field v-else v-model.number="priceInfo.price"
                                                                    type="number" density="compact" hide-details
                                                                    variant="outlined" :disabled="!variant.isActive" />
                                                            </td>
                                                        </tr>
                                                        <tr v-for="(priceInfo, index) in variant.pricePerQuantity.slice(1)"
                                                            :key="index">
                                                            <td style="width: 80px">
                                                                <v-text-field v-model.number="priceInfo.quantity"
                                                                    type="number" density="compact" hide-details
                                                                    variant="outlined" :disabled="!variant.isActive" />
                                                            </td>
                                                            <td class="text-center" style="width: 20px">-></td>
                                                            <td class="text-center" style="width: 70px;">
                                                                <v-checkbox v-model="priceInfo.isPercentage" label="%"
                                                                    hide-details
                                                                    @change="updateIsPercentage(priceInfo, variant.price)" />
                                                            </td>
                                                            <td style="width: 100px">
                                                                <v-text-field v-if="priceInfo.isPercentage"
                                                                    v-model.number="priceInfo.percentage" type="number"
                                                                    density="compact" suffix="%" hide-details
                                                                    variant="outlined" :disabled="!variant.isActive"
                                                                    min="0" max="100" />
                                                                <v-text-field v-else v-model.number="priceInfo.price"
                                                                    type="number" density="compact" hide-details
                                                                    variant="outlined" :disabled="!variant.isActive" />
                                                            </td>
                                                            <td>
                                                                <v-btn v-bind="props" variant="outlined" size="small"
                                                                    icon="mdi-delete" color="primary"
                                                                    @click="deleteQuantityPrice(variant.pricePerQuantity, index)"
                                                                    :disabled="!variant.isActive" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <v-btn color="primary" variant="outlined"
                                                    @click="pushQuantityPrice(variant.pricePerQuantity, variant.price)"
                                                    prepend-icon="mdi-plus" :disabled="!variant.isActive">
                                                    Ajout
                                                </v-btn>
                                            </td>
                                            <td class="text-center" style="width: 100px">
                                                <v-switch v-model="variant.isActive" density="compact" color="primary"
                                                    hide-details class="ma-0 pa-0" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </v-card>
                            <v-card v-else variant="outlined" class="pa-4 text-center text-grey">
                                hasen't variants.
                            </v-card>
                        </div>
                    </div>
                </div>
                <card-actions :yes="validateForm" v-model:no="addProductPriceDialog" width="300px"
                    :yesTitle="ProductPrice ? $t('actions.edit') : $t('priceLists.add')" />
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
import {
    formatPrice,
    GetUpComingDates,
    savePriceListProduct,
    saveProductPriceListItem,
} from "@/api/index";
import cardActions from "@/genericComponent/cardActions.vue"
import dateField from "@/genericComponent/date-field.vue";

export default {
    components: {
        cardActions,
        dateField
    },
    props: ['ProductPrice', 'ProductVariants'],
    data() {
        return {
            name: this.ProductPrice ? this.ProductPrice.name : null,
            description: this.ProductPrice ? this.ProductPrice.description : null,
            startDate: this.ProductPrice ? this.ProductPrice.startDate : null,
            endDate: this.ProductPrice ? this.ProductPrice.endDate : null,
            items: this.ProductPrice ? this.ProductPrice.items : [],
            itemsRoleList: [],
            msg: {},
            idProduct: this.$route.params.id,
            addProductPriceDialog: true,
            discountType: this.ProductPrice ? this.ProductPrice.discountType : 1,
            discountTypeList: [
                // {value: 0, name:'Fix price'},
                { value: 1, name: 'Percentage' },
                { value: 2, name: 'Interval by quantity' }
            ],
            itemToSave: null,
            newProductPriceId: null,
            ActiveUpCommingDates: null,
        };
    },
    mounted() {
        this.initVariant(this.ProductVariants, this.items);
    },
    watch: {
        addProductPriceDialog() {
            this.$emit("add-ProductsPrice-close-dialog");
            this.addProductPriceDialog = true;
            this.msg = [];
            this.initVariant(this.ProductVariants, this.items);
        },
        ProductVariants() {
            this.initVariant(this.ProductVariants, this.items);
        },
        ProductPrice() {
            this.addProductPriceDialog = true;
            this.name = this.ProductPrice ? this.ProductPrice.name : null;
            this.description = this.ProductPrice ? this.ProductPrice.description : null;
            this.startDate = this.ProductPrice ? this.ProductPrice.startDate : null;
            this.endDate = this.ProductPrice ? this.ProductPrice.endDate : null;
            this.initVariant(this.ProductVariants, this.items);
            this.msg = []
        },
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        async saveItem() {
            this.itemToSave = []
            this.items.forEach(i => {
                i.id = i.id ? i.id : crypto.randomUUID();
                if (i.discountType == 0) {
                    i.discountPercentage = null;
                    i.pricePerQuantity = null
                } else if (i.discountType == 1) {
                    i.discountAmount = null;
                    i.pricePerQuantity = null
                } else if (i.discountType == 2) {
                    i.discountAmount = null;
                    i.discountPercentage = null
                }

                if (i.pricePerQuantity && Array.isArray(i.pricePerQuantity)) {
                    i.pricePerQuantity.forEach(pq => {
                        if (pq.isPercentage) {
                            pq.price = null;
                        } else {
                            pq.percentage = null;
                        }
                    });
                }

                this.itemToSave.push({
                    id: i.id,
                    productId: this.idProduct,
                    productVariantId: i.productVariantId,
                    price: i.price,
                    discountPercentage: i.discountPercentage,
                    discountAmount: i.discountAmount,
                    priceType: i.priceType,
                    pricePerQuantity: i.pricePerQuantity
                })
            })
            try {
                await Promise.all(this.itemToSave.map(i =>
                    saveProductPriceListItem(this.newProductPriceId, i).then(() => {
                        this.ActiveSavedSnackBar();
                    }).catch(() => {
                        this.ActiveWarningSnackBar();
                    })
                )).finally(() => {
                    this.$emit("reloadListProductsPrice");
                });
            } catch (error) {
                console.error('Error adding Variant to price list:', error)
            } finally {
                this.addProductPriceDialog = false;
                this.$emit("reloadListProductsPrice");
                this.$emit("add-ProductsPrice-close-dialog");
            }
        },
        async initVariant(variants, priceByVariant) {
            let itemss = []
            for (const variant of variants || []) {
                const existingPrice = priceByVariant.find(item => item.productVariantId === variant.id);

                if (existingPrice) {
                    if (existingPrice.discountAmount) this.discountType = 0
                    if (existingPrice.discountPercentage) this.discountType = 1
                    if (existingPrice.pricePerQuantity.length > 0) {
                        this.discountType = 2;
                        existingPrice.pricePerQuantity.forEach(ppq => {
                            ppq.isPercentage = ppq.percentage ? true : false
                        });
                        existingPrice.pricePerQuantity.sort((a, b) => a.quantity - b.quantity);
                    }
                    existingPrice.price = variant.priceAdjustment;
                    existingPrice.startDate = variant.startDate;
                    existingPrice.endDate = variant.endDate;
                    itemss.push(existingPrice)
                } else {
                    itemss.push({
                        price: variant.priceAdjustment,
                        discountPercentage: 0,
                        discountAmount: null,
                        priceType: 0,
                        pricePerQuantity: [],
                        startDate: variant.startDate,
                        endDate: variant.endDate,
                        isActive: true,
                        options: variant.options,
                        productVariantId: variant.id
                    });
                }
            }
            this.items = itemss
        },
        pushQuantityPrice(pricePerQuantity, price) {
            let maxQuantity = 0;
            let minPrice = price;
            if (pricePerQuantity.length > 0) {
                maxQuantity = Math.max(...pricePerQuantity.map(item => item.quantity));
                minPrice = Math.min(...pricePerQuantity.map(item => item.price));
            }
            pricePerQuantity.push({ quantity: maxQuantity + 1, price: minPrice, percentage: 100, isPercentage: true });
        },
        deleteQuantityPrice(pricePerQuantity, index) {
            if (index >= 0 && index < pricePerQuantity.length) {
                pricePerQuantity.splice(index + 1, 1);
            }
        },
        getVariantTitle(variant) {
            return variant.options
                .map(opt => `${opt.name}: ${opt.value}`)
                .join(' / ')
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        formatDateForAPI(date) {
            if (!date) return null
            const d = new Date(date)
            return d.toISOString()
        },
        AddProductsPrice() {
            let itemToSave = {
                name: this.name,
                description: this.description,
                startDate: this.startDate ? this.formatDateForAPI(this.startDate) : null,
                endDate: this.endDate ? this.formatDateForAPI(this.endDate) : null,
                discountType: this.discountType,
                productId: this.$route.params.id
            }

            if (this.ProductPrice) {
                itemToSave.id = this.ProductPrice.id;
            }

            savePriceListProduct(itemToSave)
                .then((r) => {
                    this.newProductPriceId = r.data;
                    this.saveItem();
                })
                .catch(() => {
                    this.ActiveWarningSnackBar();
                }).finally(() => {
                    setTimeout(() => {
                        this.$emit("reloadListProductsPrice");
                        this.name = null;
                        this.description = null;
                        this.startDate = null;
                        this.endDate = null;
                        this.items = [];
                    }, 2000);
                });
        },
        async getActiveDates() {
            let discount = this.discountType == 0 ? [0] : [1, 2];
            await GetUpComingDates(this.idProduct, this.ProductPrice ? this.ProductPrice.id : null, discount).then((r) => {
                this.ActiveUpCommingDates = r.data
            })
        },
        hasPeriodConflict(startDate, endDate, activeDates) {
            const start = new Date(startDate);
            const end = new Date(endDate);

            return activeDates.some(({ startDate: activeStart, endDate: activeEnd }) => {
                const activeStartDate = new Date(activeStart);
                const activeEndDate = new Date(activeEnd);

                return !(end < activeStartDate || start > activeEndDate);
            });
        },
        async validateForm() {
            await this.getActiveDates();

            if (!(this.name) || (this.name).length == 0) {
                this.msg['name'] = this.$t('warningInput.isrequired', { itm: this.$t('products.title') });
            } else {
                this.msg['name'] = '';
            }

            if (this.description == null || this.description == "") {
                this.msg["description"] = this.$t('warningInput.isrequired', { itm: this.$t('products.description') });
            } else {
                this.msg["description"] = "";
            }

            if (this.startDate == "" || this.startDate == null) {
                this.msg["startDate"] = this.$t('warningInput.isrequired', { itm: this.$t('priceLists.startDate') });
            } else {
                this.msg["startDate"] = "";
            }

            if (this.endDate == "" || this.endDate == null) {
                this.msg["endDate"] = this.$t('warningInput.isrequired', { itm: this.$t('priceLists.endDate') });
            } else {
                this.msg["endDate"] = "";
            }

            if (this.msg["endDate"] == "" && this.msg["startDate"] == "") {
                if (new Date(this.startDate) > new Date(this.endDate)) {
                    this.msg["endDate"] = this.$t('warningInput.endDateBeforeStartDate');
                } else if (this.hasPeriodConflict(this.startDate, this.endDate, this.ActiveUpCommingDates)) {
                    this.msg["endDate"] = this.$t('warningInput.exist', { itm: this.$t('priceLists.endDate') });
                    this.msg["startDate"] = this.$t('warningInput.exist', { itm: this.$t('priceLists.startDate') });
                }
            }

            if (
                this.msg["name"] == "" &&
                this.msg["description"] == "" &&
                this.msg["startDate"] == "" &&
                this.msg["endDate"] == ""
            ) {
                this.AddProductsPrice();
            }
        },
        updateIsPercentage(priceInfo, variantPrice) {
            if (priceInfo.isPercentage) {
                priceInfo.percentage = (priceInfo.price / variantPrice) * 100;
            } else {
                priceInfo.price = (variantPrice * priceInfo.percentage) / 100;
            }
        }
    },
    computed: {
        currency() {
            return window.VUE_APP_CURRENCY;
        },
    }
};
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-card-title {
    font-family: inter;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #0d0849;
}

.v-card-text {
    margin-left: 40px;
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>